import type { MinimapStore } from "./store.ts";

/**
 * The page's Show coordinates choice (P1.9-T197): whether the line under the minimap's field says where the player is,
 * held by the minimap's store, which keeps each change on this device, so Settings reads and sets it as it does the
 * other per-device choices.
 *
 * @example
 * const coordinates = new CoordinatesSetting(minimap);
 * coordinates.setShow(false);
 */
export class CoordinatesSetting {
  /**
   * @param minimap The minimap's store.
   */
  constructor(private readonly minimap: Pick<MinimapStore, "getSnapshot" | "setCoordinates">) {}

  /**
   * Whether the line shows now.
   *
   * @returns The setting.
   */
  get show(): boolean {
    return this.minimap.getSnapshot().coordinates;
  }

  /**
   * Takes the viewer's choice, which the line follows at once, and keeps it.
   *
   * @param show Whether the line shows.
   */
  setShow(show: boolean): void {
    this.minimap.setCoordinates(show);
  }
}
